module.exports = function (bond) {
    var base = 0;
    var increment = 0;
    var additional = 0;
    var previousMax = 0;

    if (!bond) {
        return 0;
    }

    if (bond <= 100000) {
        return 6110;
    }

    if (bond <= 500000) {
        base = 6110;
        additional = 975;
        previousMax = 100000;
        increment = 50000;
    } else if (bond <= 1000000) {
        base = 13910;
        additional = 1885;
        previousMax = 500000;
        increment = 100000;
    } else if (bond <= 5000000) {
        base = 23335;
        additional = 1885;
        previousMax = 1000000;
        increment = 200000;
    } else {
        base = 61035;
        additional = 4750;
        previousMax = 5000000;
        increment = 1000000;
    }

    return base + Math.ceil((bond - previousMax) / increment) * additional;
};
